import React from "react"
import { Spin } from "antd"

export default () => (
  <div>
    <Spin size="large" />
  </div>
)
